export default {
  listings: state => state.listings,
  total: state => state.config.total,
  page: state => state.config.page,
  limit: state => state.config.limit,
  pages: state => Math.ceil(state.config.total / state.config.limit),
  onSale: state => state.onSale,
  averagePrice: state => state.averagePrice,
  sortBy: state => state.sortBy,
  loading: state => state.loading,
  request: (state, getters, rootState, rootGetters) => {
    return {
      cid: rootGetters['companion/cid'],
      location:
        rootGetters['companion/similarListings/filterBy/distance/location'],
      mileage: rootGetters['companion/mileage'],
      order: state.sortBy.order,
      sort: state.sortBy.type,
      filter: getters['filterBy/filters'],
      value: rootGetters['companion/retailValue'],
      vrm: rootGetters['companion/vrm'],
      year: rootGetters['companion/year'],
      vin: rootGetters['companion/vin'],
      dealerIds: rootGetters['auth/dealerIds']
    }
  }
}
